export default __webpack_public_path__ + "static/media/php.aef891fd.png";